import Authorization from "../../generics/authorization";
import { MFE_COMPONENT_IDS } from "../../utils/enums";

const pageProps = {
  componentId: MFE_COMPONENT_IDS.CIRCUIT_360,
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
